// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_3-h99","label":"index_label_2MRu5","text":"index_text_3Fm-k"};